/**
 * Bank provider display labels — single source of truth so qonto/wise/revolut
 * don't drift across TransactionsTabPage, SettingsPage, IntegrationsModal...
 * (mirrors backend BANK_PROVIDERS labels, src/backend/src/integrations/providers.js).
 */
export const PROVIDER_LABELS = {
  qonto: 'Qonto',
  wise: 'Wise',
  revolut: 'Revolut',
};
